/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Conversation, Sms } from '../models/client/conversations'
import { ApiConversation, ApiConversationSms, ApiSendCheckinSms } from '../models/api'
import { apiRequest } from './apiRequest'

const getConversation = async ({
    token,
    conversationId,
}: {
    token: string
    conversationId: string
}): Promise<Conversation> => {
    const {
        data: [conversation],
    } = await apiRequest<ApiConversation[]>({
        path: '/conversations',
        token,
        method: 'GET',
        include: ['sms'],
        parameters: {
            conversationId,
            filter: {
                conversationId,
            },
            sort: 'sms.createdAt desc',
        },
    })
    return conversation
}

const getConversationSms = async ({
    token,
    conversationId,
}: {
    token: string
    conversationId: string
}): Promise<Sms[]> => {
    const { data } = await apiRequest<ApiConversationSms[]>({
        path: '/sms',
        token,
        method: 'GET',
        parameters: {
            filter: {
                conversationId,
            },
            sort: 'createdAt asc',
        },
    })
    return data
}

const sendCheckinSms = async ({
    token,
    conversationId,
    message,
    phoneNumber,
}: {
    token: string
    conversationId: string
    message: string
    phoneNumber: string
}): Promise<{
    status: boolean
}> => {
    const { data } = await apiRequest<ApiSendCheckinSms>({
        method: 'POST',
        path: `/driver_checkins/sms`,
        token,
        data: {
            conversationId,
            message,
            phoneNumber,
        },
    })
    return data
}

export const conversationClient = {
    getConversation,
    getConversationSms,
    sendCheckinSms,
}
